/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Folder2': {
    width: 34,
    height: 28,
    viewBox: '0 0 34 28',
    data: '<path pid="0" opacity=".7" d="M33.6 5.895V26.69c0 .348-.131.68-.364.926-.234.246-.55.384-.88.384H1.4c-.371 0-.727-.155-.99-.432A1.514 1.514 0 010 26.526V1.474C0 1.083.147.708.41.432.673.155 1.03 0 1.4 0h9.333c.303 0 .598.103.84.295l4.854 3.831c.242.192.537.295.84.295H32.2c.371 0 .727.155.99.432.263.276.41.65.41 1.042z" _fill="#9BC225"/>'
  }
})
